export class DocumentGenerator {
    document_id: number;
    event_id: number | null;
    event_guest_id: number | null = null;
    event_space_id: number | null = null;
    parking_id: number | null = null;
    correspondence_id: number | null = null;
    group_id: number | null = null;
    start_date: string | null = null;
    end_date: string | null = null;
    user_id: number | null = null;
    program_menu_id: number | null = null;
    folder_id: number | null = null;
    entity_type: string | null = null;
    entity_type_id: number | null = null;
    inscription_form_id: number | null = null;
    event_guests_id: string | null = null;
    staff_ids: string | null = null;
    persons_ids: string | null = null;
    codes: string | null = null;
    outputType: string = "pdf";
    order: string | null = null;
    code_language: string | null = null;
    company_id: number | null = null;
    filters: string | null = null;
    type: number = 1;
    isExternalRequest: boolean | null = null;

    constructor(document_id: number) {
        this.document_id = document_id;
    }
}